"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interceptors = void 0;
class Interceptors {
    constructor(endpointClient, endpointInterceptor) {
        this.endpointClient = endpointClient;
        this.endpointInterceptor = endpointInterceptor;
        // this.addAuthInterceptor();
        // this.addErrorInterceptor();
        // this.addResponseInterceptor();
    }
    addAuthInterceptor() {
        this.endpointInterceptor.getAuthInterceptor().setupInterceptor();
    }
    addCacheInterceptor(storage) {
        this.endpointInterceptor.getCacheInterceptor(storage).setupInterceptor();
    }
    addDuplicateInterceptor() {
        this.endpointInterceptor.getDuplicateInterceptor().setupInterceptor();
    }
    addErrorInterceptor() {
        this.endpointInterceptor.getErrorInterceptor().setupInterceptor();
    }
    addLoadingInterceptor(onRequestStart, onRequestEnd) {
        this.endpointInterceptor
            .getLoadingInterceptor(onRequestStart, onRequestEnd)
            .setupInterceptor();
    }
    addLoggerInterceptor() {
        this.endpointInterceptor.getLoggerInterceptor().setupInterceptor();
    }
    addQueueInterceptor() {
        this.endpointInterceptor.getQueueInterceptor().setupInterceptor();
    }
    addRefreshTokenInterceptor(config) {
        this.endpointClient.setConfigurations(config);
        // this.endpointInterceptor
        //   .getRefreshTokenInterceptor()
        //   .setupInterceptor();
    }
    addResponseInterceptor() {
        this.endpointInterceptor.getResponseInterceptor().setupInterceptor();
    }
    addRetryInterceptor(config = {}) {
        this.endpointInterceptor.getRetryInterceptor(config).setupInterceptor();
    }
    registerRequestInterceptor(onFulfilled, onRejected) {
        return this.endpointClient.registerRequestInterceptor(onFulfilled, onRejected);
    }
    ejectRequestInterceptor(id) {
        this.endpointClient.ejectRequestInterceptor(id);
    }
    registerResponseInterceptor(onFulfilled, onRejected) {
        return this.endpointClient.registerResponseInterceptor(onFulfilled, onRejected);
    }
    ejectResponseInterceptor(id) {
        this.endpointClient.ejectResponseInterceptor(id);
    }
}
exports.Interceptors = Interceptors;
//# sourceMappingURL=Interceptors.js.map